import { DimensionClassComponent } from '../components/DimensionClassComponent';
import { DimensionClassProvider } from '../hooks/useDimensionClass';

export const DimensionClassPage = () => {
  return (
    <DimensionClassProvider>
      <DimensionClassComponent />
    </DimensionClassProvider>
  );
};
